import React from 'react';


export function ProfileTabPasswordHistory({ state }) {
  return (
    <div className="tab active" data-tab="passwords">
      <div className="tab__inner">
        <div className="account-history">
        <div className="account-history__item">
            <div className="account-history__body">
                <table className="account-history__table">
                <thead>
                    <tr>
                    <th>ID</th>
                    <th>ФИО</th>
                    <th>Дата</th>
                    </tr>
                </thead>
                <tbody>
                    {state.model.password_history.map(history => (
                    <tr key={history.user_id}>
                        <td>{history.user_id}</td>
                        <td>{history.last_name} {history.first_name}</td>
                        <td>{history.created_at}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            </div>
        </div>
      </div>
    </div>
  );
}
